/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>Dejan Vujovic</span>
        <div className="f-icons">
          <a
            className="github-nav"
            target="_blank"
            href="https://www.facebook.com/"
          >
           <Facebook color="white" size={"3rem"} />
          </a>
          <a
            className="github-nav"
            target="_blank"
            href="https://www.instagram.com/"
          >
           <Insta color="white" size={"3rem"} />
          </a>
          <a
            className="github-nav"
            target="_blank"
            href="https://github.com/DeVuDeveloper"
          >
           <Gitub color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
